import classNames from 'clsx';
import type { CSSProperties } from 'react';
import React from 'react';
import { useIntl } from 'react-intl';

import {
  TXTWCL_Go_to_the_next_slide,
  TXTWCL_Go_to_the_previous_slide
} from './Arrow.messages.json';
import styles from './Arrow.scss';

interface ArrowProps {
  arrowType: 'Previous' | 'Next';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: React.ReactElement | SVGSVGElement;
  position?: 'inside' | 'outside';
  className?: string;
  style?: CSSProperties;
}

const Arrow = ({
  arrowType,
  onClick,
  children,
  position = 'inside',
  className,
  style
}: ArrowProps) => {
  const { formatMessage } = useIntl();
  const arrowTypeNext = arrowType === 'Next';
  const ariaLabel = arrowTypeNext
    ? formatMessage(TXTWCL_Go_to_the_next_slide)
    : formatMessage(TXTWCL_Go_to_the_previous_slide);

  return (
    <button
      type="button"
      className={classNames(
        arrowTypeNext ? styles.nextArrow : styles.prevArrow,
        { [styles.outside]: position === 'outside' },
        className
      )}
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
    >
      {children as React.ReactNode}
    </button>
  );
};

export default Arrow;
